import { render, staticRenderFns } from "./indexLogin.vue?vue&type=template&id=20b8ddc0&scoped=true"
import script from "./indexLogin.vue?vue&type=script&lang=js"
export * from "./indexLogin.vue?vue&type=script&lang=js"
import style0 from "./indexLogin.vue?vue&type=style&index=0&id=20b8ddc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8ddc0",
  null
  
)

export default component.exports